export const getStoryblokSetting = (group, name) => {
    if (!group) {
        throw createError({
            statusCode: '500',
            statusMessage: 'Fatal: Required Param group is missing @useStoryblokSettings',
        });
    }

    const nuxtData = useNuxtData('storyblok-settings-data');

    // Define a computed property that depends on the reactive nuxtData
    const settingsStoryContent = computed(() => {
        const settingsStories = nuxtData?.data?.value?.data.stories;

        if (!settingsStories) return null;

        const settingsStory = settingsStories.find((story) => story.name.toLowerCase() === group);
        if (!settingsStory) {
            return null;
        }

        return settingsStory.content;
    });

    // If `name` is provided, return a specific value inside the computed property
    if (name) {
        return computed(() => (settingsStoryContent.value
            ? settingsStoryContent.value[name]
            : null));
    }

    // Return the full content if no `name` is specified
    return settingsStoryContent;
};

export const getStoryblokTranslation = (group, key, isRichtext = false) => {
    const nuxtData = useNuxtData('storyblok-settings-data');
    const settingsStories = nuxtData?.data?.value?.data.stories;
    if (!settingsStories) return null;

    const settingsStory = settingsStories.find((story) => story.name.toLowerCase() === 'translations');
    const data = settingsStory.content;

    if (group && key) {
        if (!data[group]) return '';

        const item = data[group].filter(
            (e) => e.key === key,
        );

        if (item.length === 1) {
            if (isRichtext) return item[0].richtext_value;
            return item[0].value;
        }
    } else {
        if (group) {
            return data[group];
        }

        return data.translations;
    }

    return '';
};
